import module from './module.js'
// Components
import './components/component.js'
import './components/detalle/component.js'
import './components/detalle/agregar/component.js'
import './components/detalle/cuentas/component.js'
import './components/detalle/cuentas/clasificacion/component.js'
import './components/detalle/editar/component.js'
import './components/detalle/eliminar/component.js'
import './components/detalle/informacion/component.js'
import './components/launcher/component.js'
// Services
import './services/Plantillas.js'
import './services/Contabilidad/ClientesCuentasContables.js'
// Routes
import './routes/contabilidad/clientesCuentasContables.js'
import './routes/contabilidad/clientesCuentasContables/lista/detalle.js'
import './routes/contabilidad/clientesCuentasContables/lista/detalle/agregar.js'
import './routes/contabilidad/clientesCuentasContables/lista/detalle/cuentas.js'
import './routes/contabilidad/clientesCuentasContables/lista/detalle/editar.js'

export default module.name



// WEBPACK FOOTER //
// ./src/contabilidad/clientescuentascontables/index.js